import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  altSection: {
    [theme.breakpoints.up('lg')]: {
      width: 350,
      margin: '0 auto'
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  content: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    alignItems: 'start',
    gap: theme.spacing(2)
  },
  table: {
    width: '100%',
    borderSpacing: 0,
    '& th, td': {
      padding: theme.spacing(1, 2),
      fontFamily: theme.typography.fontFamily,
      fontWeight: 600,
      textAlign: 'center',
      border: `1px solid ${theme.palette.secondary.contrastText}`
    },

    '& td': {
      backgroundColor: theme.palette.primary.contrastText
    }
  },
  headerRow: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  assistancePoint: {
    fontWeight: 600,
    whiteSpace: 'normal',
    '& span': {
      color: theme.palette.secondary.contrastText,
      fontWeight: 600,
      fontSize: '1rem'
    }
  },
  title: {
    color: theme.palette.disabled.main,
    borderColor: theme.palette.disabled.main
  },
  emptyMessage: {
    fontWeight: 600,
    fontSize: '.875rem',
    whiteSpace: 'pre-wrap'
  },
  pointContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2)
  }
}))
